module.exports = __webpack_public_path__ + "img/dailymotion-source.9952116c.svg";